import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contributor-add',
  templateUrl: './contributor-add.component.html',
  styleUrls: ['./contributor-add.component.css']
})
export class ContributorAddComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/contributor/contributor-add/contributor-add.component.ts